import React, { Component } from "react";
import "./Profileuser.css";
import NewHeader from "../NewHeader/NewHeader";
import { getCustomerLogin, setUserAgentUpdate } from "../axios";
import DialCode from "../PaymentDetails/DialCode";
import { Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";

class Profileuser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ChangeColor: "reviewPlanned",
      customerDetails: {},
      editProfile: false,
      editChangeProfile: false,
      firstName: "",
      errorFirst: false,
      lastName: "",
      errorLast: false,
      editLogin: false,
      mobile: "",
      errorMobile: false,
      editChangeLogin: false,
      password: "",
      errorPassword: false,
      hidden: false,
      changeClassForPassword:
        "myPrfilSprit  txtFild__rightpasswordIcon myPrfilSprit__showPswrd",
      ConfirmPassword: "",
      errorConfirm: false,
      Redirect: false,
    };
  }

  EditLogin = (firstname, lastname, mobile_number, country_code) => {
    this.setState({ editLogin: true });
    this.setState({ firstName: firstname });
    this.setState({ lastName: lastname });
    this.setState({ mobile: mobile_number });
    this.setState({ MobileCode: country_code });
  };
  CancelLogin = () => {
    this.setState({ editLogin: false });
  };

  setFirstName = (event) => {
    let firstregMatch = /^[a-zA-Z ]*$/.test(event.target.value);
    if (
      event.target.value.length > 0 &&
      firstregMatch &&
      event.target.value.length < 20
    ) {
      this.setState({ firstName: event.target.value });
      this.setState({ errorFirst: false });
    } else {
      this.setState({ firstName: event.target.value });
      this.setState({ errorFirst: true });
    }
  };

  setLastName = (event) => {
    let lastregMatch = /^[a-zA-Z ]*$/.test(event.target.value);
    if (
      event.target.value.length > 0 &&
      lastregMatch &&
      event.target.value.length < 20
    ) {
      this.setState({ lastName: event.target.value });
      this.setState({ errorLast: false });
    } else {
      this.setState({ lastName: event.target.value });
      this.setState({ errorLast: true });
    }
  };

  setMobile = (event) => {
    if (event.target.value.length > 5) {
      this.setState({ mobile: event.target.value });
      this.setState({ errorMobile: false });
    } else if (event.target.value.length > 15) {
      this.setState({ mobile: event.target.value });
      this.setState({ errorMobile: true });
    } else {
      this.setState({ mobile: event.target.value });
      this.setState({ errorMobile: true });
    }
  };
  OnChangeMobileCode = (event) => {
    this.setState({ MobileCode: event.target.value });
  };

  SaveDataLogin = (data) => {
    let CheckErrorFirstName = false;
    let CheckErrorLastName = false;
    let CheckErrorMobile = false;

    let firstregMatch = /^[a-zA-Z ]*$/.test(this.state.firstName);
    if (
      this.state.firstName.length > 0 &&
      firstregMatch &&
      this.state.firstName.length < 20
    ) {
      CheckErrorFirstName = true;
      this.setState({ errorFirst: false });
    } else {
      CheckErrorFirstName = false;
      this.setState({ errorFirst: true });
    }
    let lastregMatch = /^[a-zA-Z ]*$/.test(this.state.lastName);
    if (
      this.state.lastName.length > 0 &&
      lastregMatch &&
      this.state.lastName.length < 20
    ) {
      CheckErrorLastName = true;
      this.setState({ errorLast: false });
    } else {
      CheckErrorLastName = false;
      this.setState({ errorLast: true });
    }

    if (this.state.mobile.length > 5) {
      CheckErrorMobile = true;
      this.setState({ errorMobile: false });
    } else if (this.state.mobile.length > 15) {
      CheckErrorMobile = true;
      this.setState({ errorMobile: false });
    } else {
      CheckErrorMobile = false;
      this.setState({ errorMobile: true });
    }

    if (
      CheckErrorFirstName == true &&
      CheckErrorLastName == true &&
      CheckErrorMobile == true
    ) {
      let first_name = this.state.firstName;
      let last_name = this.state.lastName;

      let mobile_number = this.state.mobile;

      let mobileCodeData = data.country_code;
      if (this.state.MobileCode != "") {
        mobileCodeData = this.state.MobileCode;
      }
      let user_id = this.state.customerDetails?.id;

      setUserAgentUpdate(
        first_name,
        last_name,
        mobile_number,
        mobileCodeData,
        user_id
      ).then(
        (data) => {
          if (data == 1) {
            window.location.reload(true);
          }
        },
        (error) => {}
      );
    }
  };

  ShowPassword = () => {
    this.setState({ hidden: true });
  };

  HidePassword = () => {
    this.setState({ hidden: false });
  };

  EditChangeLogin = (mobile_number, password) => {
    this.setState({ editChangeLogin: true });
    this.setState({ mobile: mobile_number });
  };
  CancelChangeLogin = () => {
    this.setState({ editChangeLogin: false });
  };

  setPassword = (event) => {
    if (event.target.value.length > 0) {
      this.setState({ password: event.target.value });
      this.setState({ errorPassword: false });
    } else {
      this.setState({ password: event.target.value });
      this.setState({ errorPassword: true });
    }
  };

  setConfPassword = (event) => {
    if (
      event.target.value.length > 0 &&
      event.target.value == this.state.password
    ) {
      this.setState({ ConfirmPassword: event.target.value });
      this.setState({ errorConfirm: false });
    } else {
      this.setState({ ConfirmPassword: event.target.value });
      this.setState({ errorConfirm: true });
    }
  };

  SaveDataChangeLogin = (data) => {
    let CheckErrorPassword = false;
    let CheckErrorConfirmPassword = false;

    if (this.state.password.length > 0) {
      CheckErrorPassword = true;
      this.setState({ errorPassword: false });
    } else {
      CheckErrorPassword = false;
      this.setState({ errorPassword: true });
    }

    if (
      this.state.ConfirmPassword.length > 0 &&
      this.state.ConfirmPassword == this.state.password
    ) {
      CheckErrorConfirmPassword = true;
      this.setState({ errorConfirm: false });
    } else {
      CheckErrorConfirmPassword = false;
      this.setState({ errorConfirm: true });
    }

    if (CheckErrorPassword == true && CheckErrorConfirmPassword == true) {
      let mobileCodeData = data.country_code;
      let first_name = data.user_first_name;
      let last_name = data.user_last_name;
      let mobile_number = data.user_contact;
      let password = this.state.password;
      let user_id = data?.id;

      setUserAgentUpdate(
        first_name,
        last_name,
        mobile_number,
        mobileCodeData,
        user_id,
        password
      ).then(
        (data) => {
          if (data == 1) {
            window.location.reload(true);
          }
        },
        (error) => {}
      );
    }
  };

  componentDidMount() {
    const customerEmail = localStorage.getItem("userDetails");

    const EmailNew = JSON.parse(customerEmail);

    if (EmailNew == null) {
      this.setState({ Redirect: true });
    } else {
      getCustomerLogin(EmailNew.email).then(
        (data) => {
          this.setState({ customerDetails: data?.user });
        },
        (error) => {}
      );
    }
  }

  render() {
    if (this.state.Redirect) {
      return <Redirect to="/" />;
    }

    return (
      <div>
        <Helmet>
          <title> Profile: Holidays Seychelles</title>
          <meta
            name="keywords"
            content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"
          />
        </Helmet>
        <h1 style={{ color: "#fff" }}> Profile: Holidays Seychelles</h1>
        <NewHeader page={"inner_listing"} />
        <div className="TripContainer" id="container">
          <div className={this.state.ChangeColor} style={{ marginTop: "-5px" }}>
            <div className="landingContainer">
              <h4>My Profile</h4>
            </div>
          </div>

          {this.state.customerDetails == {} ? (
            <></>
          ) : (
            <div className="contentWrapper contentWrapper--myProfile">
              <div className="leftSecWrapper">
                <div className="profilSdeBar profilSdeBar--sticky">
                  <div className="proflPicContanr proflPicContanrNew">
                    {this.state.customerDetails?.user_first_name != "" ? (
                      <div className="proflPicContanr__nmeIniContanr">
                        <span className="latoBlack whiteText proflPicContanr__nmeIni">
                          {this.state.customerDetails?.user_first_name?.charAt(
                            0
                          )}
                        </span>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="profilSdeBar__contntWrap">
                    <p
                      className="font20 latoBlack blackText"
                      style={{ textTransform: "capitalize" }}
                    >
                      {this.state.customerDetails?.user_first_name +
                        " " +
                        this.state.customerDetails?.user_last_name}
                    </p>
                    <p className="font12 darkGreyText appendTop10">
                      Personal Profile
                    </p>
                  </div>
                </div>
              </div>

              <div className="rightSecWrapper">
                <div
                  className="lognDtalComp cm__myTripSideBar cm__myProfileTheme"
                  id="profilePageComponent1"
                >
                  <div className="detalCrdHadr undefined">
                    <div className="appendRight10">
                      <h3 className="font30 latoBold blackText">Profile</h3>
                      <p className="font18 darkGreyText appendTop10">
                        Basic info, for a faster booking experience
                      </p>
                    </div>
                    <div>
                      {this.state.editLogin == true ? (
                        <button
                          type="button"
                          className="font16 latoBold blueText btn__dtailAdEdt"
                          style={{ color: "rgb(24 133 203)", outline: 0 }}
                          onClick={this.CancelLogin}
                        >
                          Cancel
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="font16 latoBold blueText btn__dtailAdEdt"
                          onClick={() =>
                            this.EditLogin(
                              this.state.customerDetails.user_first_name,
                              this.state.customerDetails.user_last_name,
                              this.state.customerDetails.user_contact,
                              this.state.customerDetails.country_code
                            )
                          }
                          style={{ color: "rgb(24 133 203)", outline: 0 }}
                        >
                          Edit
                        </button>
                      )}
                    </div>
                  </div>
                  {this.state.editLogin == true ? (
                    <>
                      <div className="guestDtls__row" style={{ marginTop: 40 }}>
                        <div className="paymakeFlex" style={{ marginTop: 55 }}>
                          <div className="paymakeFlex column flexOne">
                            <div className="paymakeFlex">
                              <div
                                className="guestDtls__col width247 appendRight10"
                                style={{ width: 300 }}
                              >
                                <div className="textFieldCol ">
                                  <p className="font11 appendBottom10 guestDtlsTextLbl">
                                    <span className="capText">First Name</span>
                                  </p>
                                  <input
                                    type="text"
                                    className={`frmTextInput ${
                                      this.state.errorFirst ? "Err" : ""
                                    }`}
                                    placeholder="First Name"
                                    value={this.state.firstName}
                                    onChange={this.setFirstName}
                                  />
                                  {this.state.errorFirst && (
                                    <p className="error">
                                      Please enter your first name in allphabet
                                      min 1 or max 20 characters{" "}
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div
                                className="guestDtls__col width247"
                                style={{ width: 300 }}
                              >
                                <div className="textFieldCol ">
                                  <p className="font11 appendBottom10 guestDtlsTextLbl">
                                    <span className="capText">Last Name</span>
                                  </p>
                                  <input
                                    type="text"
                                    id="lName"
                                    name="lName"
                                    className={`frmTextInput ${
                                      this.state.errorLast ? "Err" : ""
                                    }`}
                                    placeholder="Last Name"
                                    value={this.state.lastName}
                                    onChange={this.setLastName}
                                  />
                                  {this.state.errorLast && (
                                    <p className="error">
                                      Please enter your last name in allphabet
                                      min 1 or max 20 characters{" "}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="paymakeFlex" style={{ marginTop: 20 }}>
                          <div className="guestDtls__col width327">
                            <p className="font11 capText appendBottom10">
                              Mobile Number
                            </p>
                            <div className="paymakeFlex textLtr">
                              <div className="guestDtls__contact">
                                <label
                                  for="mCode"
                                  className=" frmSelectCont__contact"
                                >
                                  <select
                                    id="mCode"
                                    className="frmSelect frmSelectContact"
                                    value={this.state.MobileCode}
                                    onChange={this.OnChangeMobileCode}
                                  >
                                    {DialCode.map((item, key) => (
                                      <option value={item.dial_code}>
                                        {item.name}&nbsp;({item.dial_code})
                                      </option>
                                    ))}
                                  </select>
                                </label>
                                <span className="selectedCode">
                                  {this.state.MobileCode == ""
                                    ? this.state.customerDetails.country_code
                                    : this.state.MobileCode}
                                </span>
                              </div>
                              <div className="flexOne">
                                <div className="textFieldCol ">
                                  <input
                                    type="text"
                                    id="mNo"
                                    name="mNo"
                                    className={`frmTextInput noLeftBorder ${
                                      this.state.errorMobile ? "Err" : ""
                                    }`}
                                    placeholder="Mobile Number"
                                    value={this.state.mobile}
                                    onChange={this.setMobile}
                                  />
                                  {this.state.errorMobile && (
                                    <p className="error">
                                      Please enter valid number{" "}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <button
                        type="button"
                        className="font16 latoBold blueText btn__dtailAdSave"
                        onClick={() =>
                          this.SaveDataLogin(this.state.customerDetails)
                        }
                      >
                        Save
                      </button>
                    </>
                  ) : (
                    <ul className="lognDtalComp__dtalLst">
                      <li className="profilCompont__dtalLstItm">
                        <div className="profilCompont__dtalLstItmContnt">
                          <span className="font11 darkGreyText profilCompont__detalkey">
                            FIRST NAME
                          </span>
                          <span
                            className="font16 blackText latoBold"
                            style={{ textTransform: "capitalize" }}
                          >
                            {this.state.customerDetails.user_first_name}
                          </span>
                        </div>
                      </li>
                      <li className="profilCompont__dtalLstItm">
                        <div className="profilCompont__dtalLstItmContnt">
                          <span className="font11 darkGreyText profilCompont__detalkey">
                            LAST NAME
                          </span>
                          <span
                            className="font16 blackText latoBold"
                            style={{ textTransform: "capitalize" }}
                          >
                            {this.state.customerDetails.user_last_name}
                          </span>
                        </div>
                      </li>

                      <li className="lognDtalComp__dtalLstItm">
                        <div className="lognDtalComp__dtalLstItmContnt">
                          <span className="font11 darkGreyText lognDtalComp__detalkey">
                            MOBILE NUMBER
                          </span>
                          <span className="font16 blackText latoBold">
                            &lrm;
                            {this.state.customerDetails.user_contact
                              ? this.state.customerDetails.country_code +
                                "-" +
                                this.state.customerDetails.user_contact
                              : "----"}
                          </span>
                        </div>
                      </li>
                      <li className="lognDtalComp__dtalLstItm">
                        <div className="lognDtalComp__dtalLstItmContnt">
                          <span className="font11 darkGreyText lognDtalComp__detalkey">
                            EMAIL ID
                          </span>
                          <span className="font16 blackText latoBold">
                            &lrm;{this.state.customerDetails.user_email}
                          </span>
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
                <div
                  className="lognDtalComp cm__myTripSideBar cm__myProfileTheme"
                  id="profilePageComponent1"
                >
                  <div className="detalCrdHadr undefined">
                    <div className="appendRight10">
                      <h3 className="font30 latoBold blackText">
                        Change Password
                      </h3>
                      <p className="font18 darkGreyText appendTop10">
                        Manage your mobile number and password
                      </p>
                    </div>
                    <div>
                      {this.state.editChangeLogin == true ? (
                        <button
                          type="button"
                          className="font16 latoBold blueText btn__dtailAdEdt"
                          style={{ color: "rgb(24 133 203)", outline: 0 }}
                          onClick={this.CancelChangeLogin}
                        >
                          Cancel
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="font16 latoBold blueText btn__dtailAdEdt"
                          onClick={() =>
                            this.EditChangeLogin(
                              this.state.customerDetails.user_contact,
                              this.state.customerDetails.user_password
                            )
                          }
                          style={{ color: "rgb(24 133 203)", outline: 0 }}
                        >
                          Edit
                        </button>
                      )}
                    </div>
                  </div>
                  {this.state.editChangeLogin == true ? (
                    <>
                      <div className="guestDtls__row" style={{ marginTop: 40 }}>
                        <div className="paymakeFlex">
                          <div className="guestDtls__col width327 appendRight10">
                            <div
                              className="textFieldCol "
                              style={{ position: "relative" }}
                            >
                              <p className="font11 appendBottom10 guestDtlsTextLbl">
                                <span className="capText">New Password</span>
                              </p>
                              <input
                                type={this.state.hidden ? "text" : "password"}
                                className={`frmTextInput ${
                                  this.state.errorPassword ? "Err" : ""
                                }`}
                                placeholder="New Password"
                                value={this.state.password}
                                onChange={this.setPassword}
                              />
                              {this.state.hidden == true ? (
                                <span
                                  className={`myPrfilSprit  txtFild__rightpasswordIcon myPrfilSprit__hidePswrd newreset ${
                                    this.state.errorPassword ? "ErrSpan" : ""
                                  }`}
                                  onClick={this.HidePassword}
                                ></span>
                              ) : (
                                <span
                                  className={`myPrfilSprit  txtFild__rightpasswordIcon myPrfilSprit__showPswrd newreset ${
                                    this.state.errorPassword ? "ErrSpan" : ""
                                  }`}
                                  onClick={this.ShowPassword}
                                ></span>
                              )}
                              {this.state.errorPassword && (
                                <p className="error">
                                  Please enter your password{" "}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="guestDtls__col width327 appendRight10">
                            <div
                              className="textFieldCol "
                              style={{ position: "relative" }}
                            >
                              <p className="font11 appendBottom10 guestDtlsTextLbl">
                                <span className="capText">
                                  Confirm Password
                                </span>
                              </p>
                              <input
                                type={this.state.hidden ? "text" : "password"}
                                className={`frmTextInput ${
                                  this.state.errorConfirm ? "Err" : ""
                                }`}
                                placeholder="Confirm Password"
                                value={this.state.ConfirmPassword}
                                onChange={this.setConfPassword}
                              />
                              {this.state.hidden == true ? (
                                <span
                                  className={`myPrfilSprit  txtFild__rightpasswordIcon myPrfilSprit__hidePswrd  ${
                                    this.state.errorConfirm ? "ErrSpan" : ""
                                  }`}
                                  onClick={this.HidePassword}
                                ></span>
                              ) : (
                                <span
                                  className={`myPrfilSprit  txtFild__rightpasswordIcon myPrfilSprit__showPswrd  ${
                                    this.state.errorConfirm ? "ErrSpan" : ""
                                  }`}
                                  onClick={this.ShowPassword}
                                ></span>
                              )}
                              {this.state.errorConfirm && (
                                <p className="error">Password do not match! </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <button
                        type="button"
                        className="font16 latoBold blueText btn__dtailAdSave"
                        onClick={() =>
                          this.SaveDataChangeLogin(this.state.customerDetails)
                        }
                      >
                        Save
                      </button>
                    </>
                  ) : (
                    <ul className="lognDtalComp__dtalLst">
                      <li className="lognDtalComp__dtalLstItm">
                        <div className="lognDtalComp__dtalLstItmContnt">
                          <span className="font11 darkGreyText lognDtalComp__detalkey">
                            EMAIL ID
                          </span>
                          <span className="font16 blackText latoBold">
                            &lrm;{this.state.customerDetails.user_email}
                          </span>
                        </div>
                      </li>
                      <li className="lognDtalComp__dtalLstItm">
                        <div className="lognDtalComp__dtalLstItmContnt">
                          <span className="font11 darkGreyText lognDtalComp__detalkey">
                            PASSWORD
                          </span>
                          <span
                            className="blacktext latoBold lognDtalComp__pswrdTxt"
                            style={{ WebkitTextSecurity: "disc" }}
                          >
                            123456
                          </span>
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Profileuser;
